import { GENESIS_URL } from "../urls/base-urls";
import axios from "../http-client/axios";
export async function getCertificate() {
  const resp = await axios({
    url: `${GENESIS_URL}/admin/certificate`,
    //url: `http://localhost:8303/admin/certificate?idCertificate=${idCertificate}`,
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  });
  return resp.data;  
}

export async function getTrainingById(idTraining) {  
  const resp = await axios.get(`${GENESIS_URL}/training?id=${idTraining}`);
  return resp.data;
}

export async function deleteLinkCertificateTraining(idLink) { 
  return await axios({
    url: `${GENESIS_URL}/admin/link?idLink=${idLink}`,
    //url: `http://localhost:8303/admin/link?idLink=${idLink}`,

    method: "delete",
    data: {},
    headers: {
      "content-type": "application/json"
    },
  });
}

export async function getLinkedCertificates(
  idTraining
) {
  
  const resp = await axios({
    url: `${GENESIS_URL}/admin/links-training?idTraining=${idTraining}`,
    //url: `http://localhost:8303/admin/links-training?idTraining=${idTraining}`,

    method: "get",
    data: {},
    headers: {
      "content-type": "application/json",
    },
  });

  return resp.data;  
 
}
export async function getCertificates(idTraining) { 
  const resp = await axios({
    url: `${GENESIS_URL}/certificate/list?idTraining=${idTraining}`,
    //url: `http://localhost:8303/certificate/list?idTraining=${idTraining}`,

    method: "get",
    data: {},
    headers: {
      "content-type": "application/json",
    },
  });

  return resp.data;  
}

export async function getLink(
  status, name, page, size
) {
  
  let query = `?status=${status}&page=${page}&size=${size}`;

  if(name)
    query += `&name=${name}`

  const resp = await axios.get(
    `${GENESIS_URL}/admin/links${query}`
    // `http://localhost:8303/admin/links${query}`,
  );
  return mapperToResponse(resp.data);
}

export async function deleteLink(id) {
  const resp = await axios({
    url: `${GENESIS_URL}/admin/certificate-link?id=${id}`,
    // url: `http://localhost:8303/admin/certificate/training`,

    method: "delete",
    data: {},
    headers: {
      "content-type": "application/json",
    },
  });

  return resp.data;  
}


export async function saveLinkCertificateTraining(formData) {
  const resp = await axios({
    url: `${GENESIS_URL}/admin/link`,
    //url: `http://localhost:8303/admin/link`,

    method: "post",
    data: formData,
    headers: {
      "content-type": "application/json"
    },
  });
  return resp.data;  
}


function mapperToResponse(data) { 
  data.items.forEach(link => {
    if (link.linkId == null) {
      link.initialDateLink = ''
      link.endDateCertificate = ''
    } else { 
      if (link.initialDateLink == null) link.initialDateLink = 'Indeterminado'
      if (link.endDateCertificate == null) link.endDateCertificate = 'Indeterminado'
    }
    
    if (link.endDateTraining == null) link.endDateTraining = 'Indeterminado'
  })
  return data
}
/**
function formatLinkedCertificates(data) { 
  const obj = {
    warn: null,
    error: null,
  }

  data.forEach(cert => { 
    cert.statusActivation = null;
    cert.status = cert.status == 'ENABLED' ? true : false; 
    cert.startDateObj = obj;
    cert.endDateObj = obj;
  })

  return data;
}
*/